/*
Defines the custom element <ravel-recorder>
*/

import { RavelRecorder } from './src/RavelRecorder.js';

customElements.define('ravel-recorder', RavelRecorder);
